import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { mergeConductorComponents } from "@faire/sdui/conductor/utils/mergeConductorComponents";
import { QueryParameters as ConductorComponentsQueryParameters } from "@faire/web-api--source/endpoints/www/api/conductor/components/get";
import { useQuery as useGetConductorComponentsQuery } from "@faire/web-api--source/endpoints/www/api/conductor/components/get-hooks";
import { useInvalidateQuery as useInvalidateConductorComponentsQuery } from "@faire/web-api--source/endpoints/www/api/conductor/components/get-hooks";
import { useCallback } from "react";

import { IGetConductorComponentProps, IConductorComponentData } from "./types";

/**
 * Fetches up to 4 conductor SDUI components for the given parameters.
 * This is a temporary solution for fetching multiple viewports.
 * TODO (FD-281768): We should be using single component endpoint instead and have a merged view layout
 * However, we don't have the backend capacity to do this so it'll be a temporary fix on FE.
 */
export const useConductorComponents = (
  parameters: IGetConductorComponentProps
): IConductorComponentData => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const queryParams = ConductorComponentsQueryParameters.build({
    ...parameters,
    limit: 4,
  });

  const { data, isPending } = useGetConductorComponentsQuery(queryParams, {
    enabled: isLoggedInRetailer && !!queryParams,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  const invalidateConductorComponentsQueryBase =
    useInvalidateConductorComponentsQuery();

  const invalidateConductorComponentsQuery = useCallback(() => {
    return invalidateConductorComponentsQueryBase(queryParams, undefined, {
      refetchType: "active",
    });
  }, [invalidateConductorComponentsQueryBase, queryParams]);

  const mergedConductorSduiViewLayout = mergeConductorComponents(
    data?.components
  );

  return {
    componentToken: data?.components?.[0]?.token,
    shouldShowConductor: !!mergedConductorSduiViewLayout,
    conductorSduiViewLayout:
      mergedConductorSduiViewLayout?.sdui_component?.view_layout,
    conductorBuilderModelName: undefined,
    isConductorComponentPending: isPending,
    featureName: data?.components?.[0]?.feature_name,
    invalidateConductorComponentQuery: invalidateConductorComponentsQuery,
  };
};
